module.exports = __webpack_public_path__ + "static/media/RXHacker-Pro-Introduction.Notification.082574a9.pdf";